import React, { Component } from 'react';

import Map from '../map/Map';

class FindAnEvent extends Component {
  render() {
    return (
      <div className="thunderbolt__page">
        <Map cultureCode={this.props.cultureCode}></Map>
      </div>
    );
  }
}

export default FindAnEvent;
